/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_DeniedInputs */



/**
* | output |
* | --- |
* | "Single sign-on was cancelled at your company's sign-in page. Try again when you are ready." |
*
* @param {Signin_Sso_X15_DeniedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_denied = /** @type {((inputs?: Signin_Sso_X15_DeniedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_DeniedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Single sign-on was cancelled at your company's sign-in page. Try again when you are ready.")
});